;(function($){
    'use strict';
    let $document                                   = $(document),
        $body                                       = $('body'),
        $window                                     = $(window),
        $biolife_slide                              = $('.biolife-carousel'),
        $scroll_items                               = $('.biolife-cart-info .minicart-block ul.products'),
        $vertical_menu                              = $('#header .vertical-category-block:not(.always)'),
        $menu_mobile                                = $('.clone-main-menu'),
        $sticky_object                              = $('.biolife-sticky-object'),
        $shop_filter                                = $('#top-functions-area'),
        $biolife_select                             = $('select:not(.hidden)'),
        $rating_form                                = $('.comment-form-rating'),
        $accodition                                 = $('.biolife-accodition'),
        $block_tab                                  = $('.biolife-tab-contain, .ovictab-contain'),
        $biolife_countdown                          = $('.biolife-countdown:not(.under_testing_mode)'),
        $biolife_popup                              = $('.biolife-popup'),
        $pre_loader                                 = $('#biof-loading'),
        $btn_scroll_top                             = $('.btn-scroll-top'),
        $biolife_stretch_the_right_background       = $('.biolife-stretch-the-right-background'),
        $js_seach_inline                            = $('.js_seach_inline'),
        $product_packages                           = $('.product-packages__head'),
        $equal_elements                             = $('.equal_contain');

    /*Create Mobile Menu*/
    if( $menu_mobile.length ) {
        $menu_mobile.biolife_menu_mobile();
    }

    /*Register Quickview Box*/
    if($('#biolife-quickview-block').length){
        $document.on('click','.btn_call_quickview', function (e){
            if($(window).width() > 991){
                e.preventDefault();
                $('body').trigger( 'open-overlay',['open-quickview-block']);
                $('#biolife-quickview-block-popup').modal('show');
            }
        })
    }

    /*Register Select Element*/
    /*if( $biolife_select.length ){
        $biolife_select.niceSelect()
    }*/

    /*Minicart Scroll handle*/
    if( $scroll_items.length){
        $scroll_items.niceScroll();
    }

    /*Carousel Handle*/
    if( $biolife_slide.length){
        $biolife_slide.biolife_init_carousel();
    }

    /*Vertical Menu Handle*/
    if( $vertical_menu.length){
        $vertical_menu.biolife_vertical_menu();
    }

    /*Toggle shop filter on mobile*/
    if( $shop_filter.length){
        $shop_filter.on('click', 'a.icon-for-mobile', function (e) {
            e.preventDefault();
            $body.trigger( 'open-overlay', ['top-refine-opened']);
        });
    }

    /*Header Sticky*/
    if( $sticky_object.length){
        $sticky_object.biolife_sticky_header();
    }

    /*JS Search Inline*/
    if( $js_seach_inline.length ){
        $js_seach_inline.on( 'click', '.js_btn_click , .mobile-overlay' , function (e) {
            e.preventDefault();
            var $this   = $(this),
                $parent = $this.closest('.js_seach_inline');
            $parent.toggleClass('search-active');
            if( $parent.hasClass('search-active') ){
                $parent.find('.biolife-input__text').focus();
            }
        });
    }

    /*Tab button*/
    if( $block_tab.length){
        $block_tab.biolife_tab();
    }

    /*Rating on single product*/
    if( $rating_form.length){
        $rating_form.biolife_rating_form_handle();
    }

    /*Accodition menu*/
    if( $accodition.length){
        $accodition.biolife_accodition_handle();
    }

    /*Countdown*/
    if( $biolife_countdown.length){
        $biolife_countdown.biolife_countdown();
    }

    /*stretch right background*/
    if( $biolife_stretch_the_right_background.length){
        $biolife_stretch_the_right_background.biolife_stretch_the_right_background();
        window.onresize = function(event) {
            event.preventDefault();
            $biolife_stretch_the_right_background.biolife_stretch_the_right_background();
        };
    }

    /*Popup*/
    if( $biolife_popup.length){
        $biolife_popup.modal('show');
    }

    /*Scroll to top*/
    if( $btn_scroll_top.length){
        $window.on('scroll', function () {
            if ($window.scrollTop() >= 800) {
                $btn_scroll_top.addClass('showUp');
            } else {
                $btn_scroll_top.removeClass('showUp');
            }
        });
        $btn_scroll_top.on('click', function () {
            $('html, body').animate({
                scrollTop: 0
            }, 1500);
        });
    }

    if( $product_packages.length ){
        $product_packages.on( 'click' , '.actions .btn' , function (e) {
            e.preventDefault();
            var $btn = $(this),
                label = $btn.data('label'),
                $parent = $btn.parent();

            if( $parent.hasClass('active') ) return 0;

            $parent.siblings().removeClass('active');
            $parent.addClass('active');
            var $prices =  $parent.closest('.product-packages').find('.prices');

            if( $prices.length ){
                $prices.find('.active').removeClass('active');
                $prices.find('[data-label='+label+']').addClass('active');
            }
        });
    }

    if( $equal_elements.length ){
        $equal_elements.biolife_equal_elements();
    }
    /*Events On Document*/
    $document.on('click','.minicart-item .action .edit',function (e){
        e.preventDefault();
        let $this       = $(this),
            cart_item   = $this.closest('.minicart-item'),
            input_field = cart_item.find('.input-qty'),
            curent_val  = input_field.val();
        if( !cart_item.hasClass('editing')){
            cart_item.addClass('editing');
            input_field.removeAttr('disabled').val('');
            input_field.val(curent_val).focus();
        }else{
            cart_item.removeClass('editing');
            input_field.attr('disabled', 'disabled');
        }
    });

    $document.on('click','.minicart-item .action .remove',function (e){
        e.preventDefault();
        let $this = $(this);
        $this.closest('li').remove();
        $('body').trigger( 'update-minicart',[ $this.closest('.cart-inner') ]);
    });

    $document.on('click touchstart','#overlay',function (e){
        e.preventDefault();
        let _this           = $(this),
            current_class   = _this.attr('data-object'),
            class_list      = 'open-overlay';
        if( typeof current_class !== "undefined" && current_class !== ''){
            class_list +=' ' + current_class;
            _this.attr('data-object','');
        }
        $('body').removeClass(class_list);
    });

    $document.on('click','.mobile-search .btn-close',function (e){
        e.preventDefault();
        $('body').removeClass('open-overlay open-mobile-search');
    });

    $document.on('click','.mobile-search .open-searchbox, .dsktp-open-searchbox',function (e){
        e.preventDefault();
        $body.trigger( 'open-overlay',['open-mobile-search']);
    });

    $document.on('click','.mobile-footer .btn-toggle, .mobile-menu-toggle .btn-toggle',function (e){
        e.preventDefault();
        let class_name = $(this).attr('data-object');
        if(typeof class_name !=="undefined"){
            $body.trigger( 'open-overlay',[class_name]);
        }
    });

    $document.on('click','.biolife-mobile-panels .biolife-close-btn, .biolife-panels-actions-wrap .biolife-close-btn, .btn-close-quickview', function (e){
        e.preventDefault();
        let class_name = $(this).attr('data-object');
        if(typeof class_name !== 'undefined'){
            $body.trigger('close-overlay', [class_name]);
        }
    });

    $document.on('click','.biolife-filter .check-list .check-link', function (e){
        e.preventDefault();
        let this_item   = $(this),
            father      = this_item.parent(),
            contain     = this_item.closest('ul.check-list');
        if( !contain.hasClass('multiple')){
            father.siblings().removeClass('selected');
        }
        father.toggleClass('selected');
    });

    $document.on('click','.biolife-filter .color-list .c-link', function (e){
        e.preventDefault();
        let father = $(this).parent();
        father.siblings().removeClass('selected');
        father.toggleClass('selected');
    });

    $document.on('click','.qty-input .qty-btn', function (e){
        e.preventDefault();
        let btn     = $(this),
            input   = btn.siblings("input[name^='qty']");
        if(input.length){
            let current_val = parseInt(input.val(),10),
                max_val     = parseInt(input.data('max_value'),10),
                step        = parseInt(input.data('step'),10);
            if( btn.hasClass('btn-up')){
                current_val += step;
                if ( current_val <= max_val ){
                    input.val(current_val);
                }
            }else{
                current_val -= step;
                if ( current_val > 0 ){
                    input.val(current_val);
                }
            }
        }
    });

    /*Events On Body Target*/
    $body.on('update-minicart', function ( el, block_minicart) {
        if( block_minicart.find('ul.products li').length === 0 ){
            block_minicart.html('<p class="minicart-empty">No product in your cart</p>');
        }
    });

    $body.on('open-overlay', function ( e, classes) {
        let addition_classes = 'open-overlay';
        if( classes !== ''){
            addition_classes +=' '+ classes;
            $('#overlay').attr('data-object', classes);
        }
        $body.addClass(addition_classes);
    });

    $body.on('close-overlay', function ( e, object) {
        let classes = 'open-overlay';
        if( object !== ''){
            classes +=' '+ object;
            $('#overlay').attr('data-object','');
        }
        $body.removeClass(classes);
    });

    /*Create overlay Element*/
    $body.append('<div  id="overlay"></div>');


    $.fn.biolife_best_equal_products();

    /*preload handle*/
    $window.on('load', function() {
        if( $pre_loader.length){
            $pre_loader.fadeOut(800);
            setTimeout(function(){
                $pre_loader.remove();
            },3000);
        }
    });

    /*******************************
    /* CUSTOM                      *
    /******************************/

    // VARIABLES
    //----------------------------------//
    var baseHref    = $('base').attr('href'),
        slang       = $('html').attr('lang'),
        ajaxLang    = slang;

    if($('body').hasClass('faq')) {

        $('#accordion').collapse()

    }

    Fancybox.bind("[data-fancybox]", {
        caption: function (fancybox, carousel, slide) {
            return (
              slide.caption
            );
          },
    });

    var orejimeConfig = {
        elementID: "orejime",
        appElement: ".biolife-body",
        cookieExpiresAfterDays: 365,
        stringifyCookie: (contents) => JSON.stringify(contents),
        parseCookie: (cookie) => JSON.parse(cookie),
        privacyPolicy: "https://miammm.be/fr/politique-de-confidentialite",
        default: true,
        mustConsent: false,
        mustNotice: false,
        lang: "fr",
        logo: false,
        debug: false,
        translations: {
            en: {
                consentModal: {
                    description: "This is an example of how to override an existing translation already used by Orejime",
                },
                inlineTracker: {
                    description: "Example of an inline tracking script",
                },
                externalTracker: {
                    description: "Example of an external tracking script",
                },
                purposes: {
                    analytics: "Analytics",
                    security: "Security"
                },
                categories: {
                    analytics: {
                        description: "A long form description of the category."
                    }
                }
            },
        },

        apps: [
            {
                name: "google-tag-manager",
                title: "Google Tag Manager",
                cookies: [
                    "_ga",
                    "_gat",
                    "_gid",
                    "__utma",
                    "__utmb",
                    "__utmc",
                    "__utmt",
                    "__utmz"
                ],
                purposes: ["analytics"],
                callback: function(consent, app){
                    // This is an example callback function.
                    //console.log("User consent for app " + app.name + ": consent=" + consent)
                },
                required: false,
                optOut: false,
                default: true,
                onlyOnce: true,
            }
        ]
    }

    Orejime.init(orejimeConfig);




    if ($('#searchMeiliGlobal').length > 0) {

        var templateProducts = $('#template-products').html(),
            indexName = $('#searchMeiliGlobal').data('index'),
            selected = 0;

        const searchProducts = instantsearch({
            searchClient: instantMeiliSearch(
                'https://search.miammm.be',
                'MDEzNDMwNjVhNGE5ZjQyYjkxYTVhZjFj'
            ),
            indexName: indexName,
            routing: true,
            searchParameters: {
                /*facetFilters: [
                    [
                        'objectType:product',
                        'objectType:categoryProduct'
                    ],
                    [
                        'level:1',
                        'level:2'
                    ],
                    'brand:' + $brand
                ],*/
                hitsPerPage: 25
            }
        });

        $('#searchMeiliGlobal').on('click', function () {
            if (selected === 0) {
                searchProducts.start();
                selected = 1;
            }
        });

        searchProducts.addWidget(
            instantsearch.widgets.searchBox({
                container: '#searchMeiliGlobal',
                placeholder: 'Search for products',
                autofocus: true,
                poweredBy: false,
                showReset: true,
                loadingIndicator: false,
                magnifier: false,
            })
        );

        searchProducts.addWidget(
            instantsearch.widgets.hits({
                container: '#searchMeiliResult',
                templates: {
                    empty: 'No results',
                    allItems: function (object) {
                        object.hits.unshift({name: object.name, link: object.link, producer: object.producer, picture: object.picture}); // append before all query value
                        delete object.hits['__escaped']; // remove this key in array
                        return Mustache.render(templateProducts, object.hits);
                        //$('#template-products').css('display','block');
                    },
                    reset: true
                },
                escapeHits: true,
                transformData: {
                    allItems: function (content) {
                        return { hits: content.hits };
                    }
                },
            })
        );

        /*$('#searchMeiliResult').on('click', 'li', function () {
            var url = $(this).attr('href');
            window.location = url;
        });*/
    }

    /*******************************
    /* BASKET MANAGER              *
    /******************************/
    $(document).on('click','.add_product_to_basket', function() {

        // Variables
        var quantity        = $(this).data('quantity'),
            reference       = $(this).data('reference'),
            producttype     = $(this).data('type');

        // ajax query
        $.ajax({
            type: 'POST',
            url: ajaxLang + '/ajax-basket',
            data: {
                reference: reference,
                producttype: producttype,
                function: 'findProduct'
            },
            dataType: "json",
            cache: false,
        }).done(function (response) {

            // PRODUCT FOUND AT FIRST SEARCH
            if(response.status=='found') {

                // Classic barcode
                if(response.type=='barcode') {

                    var product_id = response.id;

                    // Add product to basket
                    $.ajax({
                        type: 'POST',
                        url: ajaxLang + '/ajax-basket',
                        data: {
                            type:response.type,
                            reference:reference,
                            productId: response.id,
                            origin: 'eshop',
                            function: 'addProductToSale'
                        },
                        dataType: "json",
                        cache: false,
                    }).done(function(response) {

                        if(response.status=='success') {

                            // update total
                            $('.basket_quantity').html(response.total);
                            $('.show_total').html(response.grandtotal+'&nbsp;€');
                            // Page product
                            $('.btn_add_basket.pi_'+product_id).addClass('hidden');
                            $('.update_quantity.pi_'+product_id).removeClass('hidden');
                            $('.update_quantity.pi_'+product_id).data('key',response.cell_key);

                        } else {
                            alert('error');
                        }
                    })

                // Weight or Price based
                } else if(response.type=='weight' || response.type=='price') {

                    var product_id = response.id;

                    // Add product to basket
                    $.ajax({
                        type: 'POST',
                        url: ajaxLang + '/ajax-basket',
                        data: {
                            type:response.type,
                            reference:reference,
                            productId: response.id,
                            origin: 'eshop',
                            function: 'addProductToSale'
                        },
                        dataType: "json",
                        cache: false,
                    }).done(function (response) {

                        if(response.status=='success') {

                            // update total
                            $('.basket_quantity').html(response.total);
                            $('.show_total').html(response.grandtotal+'&nbsp;€');
                            // Page product
                            $('.btn_add_basket.pi_'+product_id).addClass('hidden');
                            $('.update_quantity.pi_'+product_id).removeClass('hidden');
                            $('.update_quantity.pi_'+product_id).data('key',response.cell_key);

                        } else {
                            alert('error');
                        }
                    })

                }

            } else {

                alert('Erreur de Code-Barre.');

            }

        })

    })

    $(document).on('change','.update_quantity', function(e) {

        e.preventDefault();

        var key          = $(this).data('key'),
            product_id   = $(this).data('product-id'),
            new_quantity = $(this).val();

        // ajax query
        $.ajax({
            type: 'POST',
            url: ajaxLang + '/ajax-basket',
            data: {
                key: key,
                new_quantity: new_quantity,
                product_id: product_id,
                function: 'updateQuantity'
            },
            dataType: "json",
            cache: false,
        }).done(function (response) {


            // UPDATE VALUES
            if(response.status=='success') {

                $('#update_product_total_'+key).text(response.total);

                if(response.remove==true) {
                    $('#cell_'+key).remove();
                    // Onlye for product.php page
                    if($('body').hasClass('product')) {
                        $('.btn_add_basket.pi_'+product_id).removeClass('hidden');
                        $('.update_quantity.pi_'+product_id).addClass('hidden');
                        $('.update_quantity.pi_'+product_id).data('key','');
                        $('.update_quantity.pi_'+product_id).val('1');
                    }
                }

                // update total
                $('.basket_quantity').html(response.totalproduct);
                $('.show_total').html(response.grandtotal+'&nbsp;€');

            } else {

                alert('Error with pair key/product_id. Stop manipulating the dom…');

            }

        })

    });

    if($('body').hasClass('user_create')) {

        $('.g-recaptcha').on('click', function () {

            // Recaptcha
            var target = $(this).data('target'),
                publicKey = $(this).data('rc-public-key');

            grecaptcha.execute(publicKey, {
                action: 'create_user'
            }).then(function(token) {
                $('#'+target).val(token);
                $('#user_create').submit();
            });

        });

    }


    if($('body').hasClass('user_profile')) {

        $('.verify_phone').click(function() {

            var phonenumber     = $('#phonenumber').val();

            // ajax query
            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    phonenumber: phonenumber,
                    function: 'sendVerificationCode'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {

                // UPDATE VALUES
                if(response.status=='success') {

                    $('.verify_phone').addClass('hidden');
                    $('.show_code').removeClass('hidden');
                    $('#phonenumber').val(response.phonenumber);

                } else if(response.status=='error') {

                    $('.verify_phone').removeClass('hidden');
                    $('.show_code').addClass('hidden');
                    $('#phonenumber').val(response.phonenumber);

                    alert('le numéro de gsm n\'est pas correct.')

                }

            })

        })

        // Verify code
        $('.verify_code_btn').click(function() {

            var verification_code     = $('#verification_code').val();

            // ajax query
            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    verification_code: verification_code,
                    function: 'verifyCode'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {

                // UPDATE VALUES
                if(response.status=='success') {

                    $('.show_code').addClass('hidden');
                    alert('Le code de vérification introduit est correct. Votre numéro de GSM est validé!');

                } else {

                    alert('Le code de vérification introduit est incorrect. Veuillez ré-essayer.');
                }

            })

        })

        // change city
        $('select[name="city"]').on('change',function() {

            var value = $(this).val();

            if(value=='other') {
                $('#other_city').removeClass('hidden');
            } else {
                $('#other_city').addClass('hidden');
            }

        })

    }

    if($('body').hasClass('user_delivery')) {

        $('input[name="type"]').on('change',function() {

            var type = $(this).val();

            if(type=='pickup') {
                $('#pickup').removeClass('hidden');
                $('#delivery').addClass('hidden');
                $('#submit_form').removeClass('hidden');
            } else if(type=='delivery') {
                $('#pickup').addClass('hidden');
                $('#delivery').removeClass('hidden');
                $('#submit_form').removeClass('hidden');
            }


        });

    }

    $('.show_password').click(function() {

        var password = $('input[name="password"]').attr('type'),
            password_confirm = $('input[name="password_confirm"]').attr('type');

        // show password
        if(password == 'password') {
            $('input[name="password"]').get(0).type = 'text';
        }  else {
            $('input[name="password"]').get(0).type = 'password';
        }

        // show password_confirm
        if(password_confirm == 'password') {
            $('input[name="password_confirm"]').get(0).type = 'text';
        }  else {
            $('input[name="password_confirm"]').get(0).type = 'password';
        }

    })



})(jQuery);
